import { useState, useEffect } from "react";
import { useIsMounted } from "../../../hooks/useIsMounted";
import { TrafficSource } from "../../../services/TrafficSource";
import { textFieldValid } from "../../../helpers/validation";

export const useFetchTrafficSources = ({
  filterValues,
  filtersClearToggle
}) => {
  const [trafficSources, setTrafficSources] = useState([]);
  const [loadingTrafficSources, setLoadingTrafficSources] = useState({
    isLoading: false,
    error: false
  });
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(50);
  const [orderBy, setOrderBy] = useState("id");
  const [orderDirection, setOrderDirection] = useState("DESC");
  const [total, setTotal] = useState(0);

  function getParams() {
    let params = {};
    const { query, archivedData } = filterValues;
    if (textFieldValid(query)) {
      params["q"] = query.trim();
    }

    if (archivedData) {
      params["archived"] = archivedData;
    }
    if (orderBy) {
      params["order_by"] = orderBy;
    }
    params["order_direction"] = orderDirection;

    params["page"] = page;
    params["size"] = size;

    return params;
  }

  const isMounted = useIsMounted();

  async function getTrafficSources() {
    try {
      setLoadingTrafficSources({ isLoading: true, error: false });
      const trafficSources = await TrafficSource.fetchTrafficSources(
        getParams()
      );
      if (trafficSources.success && isMounted()) {
        setTrafficSources(trafficSources.data.traffic_sources);
        setTotal(trafficSources.data.total);
        setLoadingTrafficSources({ isLoading: false, error: false });
      } else {
        throw new Error(trafficSources.error.message);
      }
    } catch (error) {
      if (isMounted()) {
        setTrafficSources([]);
        setLoadingTrafficSources({ isLoading: false, error: true });
      }
      console.trace(error.message || error);
    }
  }

  useEffect(() => {
    getTrafficSources();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    page,
    size,
    orderBy,
    orderDirection,
    filtersClearToggle,
    filterValues.archivedData
  ]);

  return {
    loadingTrafficSources,
    trafficSources,
    page,
    setPage,
    size,
    setSize,
    orderBy,
    setOrderBy,
    orderDirection,
    setOrderDirection,
    total,
    getTrafficSources
  };
};
